<template>
  <div>
    <Card>
      <div slot="title">客户需求</div>
      <div slot="extra">
        <Button type="primary" size="small" @click="customerFileSelect">上传文件</Button>
        <input type="file" ref="customerFile" style="display:none" @change="customerFileUpload">
      </div>
      <Table :columns="demandColumns" :data="customerList"></Table>
    </Card>
    <Card>
      <div slot="title">委托协议</div>
      <div slot="extra">
        <Button type="primary" @click="standardFile('fill')" size="small" style="margin-right:5px;" :disabled="editPermission">委托协议参数填写</Button>
        <Button type="primary" @click="standardFile('download')" size="small" style="margin-right:5px;">标准委托协议下载</Button>
        <Button type="primary" size="small" @click="entrustFileSelect">上传文件</Button>
        <input type="file" ref="entrustFile" style="display:none" @change="entrustFileUpload">
      </div>
      <Table :columns="demandColumns" :data="entrustList"></Table>
    </Card>
    <!-- <Modal v-model="downloadRecordVisible" title="下载记录" :mask-closable="false">
      <div v-for="record in downloadRecord" class="record-item">
        <span>{{record.downloadpeople | filterUser}}</span>
        <span class="time">{{record.downloadtime | formatTime}}</span>
      </div>
      <div slot="footer"></div>
    </Modal> -->
    <!-- 委托协议 -->
    <Modal class="proxy-modal" v-model="standardFileVisible" title="委托协议" :mask-closable="false" width="1000">
      <iframe :src="standardFileUrl" style="width:100%;height:600px;" v-if="commissionFileType == 'download'"></iframe>
      <agreement 
        :projectData="projectData" 
        ref="agreement" 
        :argumentData="argumentData" 
        @visible="standardFileVisible = false"
        :commissionType="commissionType"
        v-else>
      </agreement>
      <div slot="footer">
        <Button @click="save" type="primary" v-if="commissionFileType !== 'download'">保存</Button>
      </div>
    </Modal>
    <Modal title="委托协议版本选择" v-model="commissionModalChoose">
      <RadioGroup v-model="commissionType">
        <div v-show="commissionFileType == 'download'">
          <span>固定版本：</span>
          <Radio label="staticStandard">标准版本</Radio>
          <Radio label="staticArmyYear">军队非涉密（年度）</Radio>
          <Radio label="staticArmySingle">军队非涉密（单项）</Radio>
        </div>
        <div style="margin-top:10px">
          <span>{{ commissionFileType == 'download' ? '可修改版本：' : '版本选择：' }}</span>
          <Radio label="standard">标准版本</Radio>
          <Radio label="armyYear">军队非涉密（年度）</Radio>
          <Radio label="armySingle">军队非涉密（单项）</Radio>
        </div>
      </RadioGroup>
      <div slot="footer">
        <Button @click="commissionModalChoose=false">取消</Button>
        <Button @click="commissionConfirm" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import qs from 'qs'
import agreement from '@/components/agreement'
import localFile from '@/lib/localFile'

export default {
  props: {
    projectData: {
      type: Object
    },
    editPermission: {
      default: false
    }
  },
  components: {
    agreement
  },
  data() {
    return {
      commissionType: '',
      commissionModalChoose: false,
      commissionFileType: '',
      demandColumns: [
        {
          title: '文件名称',
          key: 'fileName'
        },
        {
          title: '文件类别',
          key: 'fileTypeName',
          width: 100
        },
        {
          title: '上传人员',
          key: 'uploadPerson',
          width: 100,
        },
        {
          title: '上传时间',
          width: 180,
          render: (h, params) => {
            // let time = new Date(params.row.uploadTime)
            // time = time.toLocaleString().replace(/\//g, '-')
            // return h('span', time)
            if (params.row.uploadTime) {
              return h('span', params.row.uploadTime.split('.')[0].replace('T', ' '))
            }
            return ''
          }
        },
        {
          title: '操作',
          width: 200,
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'center'
              }
            }, [
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px'
                  },
                  on: {
                    'click': () => {
                      this.downloadFile(params.row)
                    }
                  }
                }, '下载'),
                // h('Button', {
                //   props: {
                //     type: 'primary',
                //     size: 'small',
                //   },
                //   style: {
                //     marginRight: '10px'
                //   },
                //   on: {
                //     click: () => {
                //       this.showDownloadRecord(params.row)
                //     }
                //   }
                // }, '下载记录')
              ])
          }
        },
      ],
      customerList: [],
      entrustList: [],
      downloadRecordVisible: false,
      downloadRecord: [],
      standardFileVisible: false,
      standardFileUrl: '',
      argumentData: {}
    }
  },
  computed: {
    username () {
      return this.$store.state.session.user.name
    }
  },
  methods: {
    // 获取客户需求委托协议文件
    // async getFileList1(fileType) {
    //   let rep = await axios.post(`http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpGetFileList?npid=${this.projectData.id}&fl=${fileType}`)
    //   if (fileType === 1) {
    //     this.customerList = rep.data.result
    //     if (this.customerList.length > 0 && this.projectData.projectState === '等待用户需求') {
    //       // 检测客户需求文件，如果有文件且项目状态为等待用户需求，则修改项目状态
    //       let rep = await ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
    //         id: this.projectData.id,
    //         projectState: '文件编制中'
    //       })
    //     }
    //   } else if (fileType === 13) {
    //     this.entrustList = rep.data.result
    //   }
    // },
    // 获取客户需求委托协议文件
    async getFileList(fileType) {
      if (!fileType) {
        return false
      }
      const params = {
        filter: `fileTypeId=="${fileType}" and projectId=="${this.projectData.id}"`
      }
      let rep = await ajax.get(requestUrls.clfile.getList, { params })
      if (fileType === 1) {
        this.customerList = rep.data.result
        if (this.customerList.length > 0 && this.projectData.projectState === '等待用户需求') {
          // 检测客户需求文件，如果有文件且项目状态为等待用户需求，则修改项目状态
          let rep = await ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
            id: this.projectData.id,
            projectState: '文件编制中'
          })
        }
      } else if (fileType === 13) {
        this.entrustList = rep.data.result
      }
    },
    customerFileSelect() {
      this.$refs.customerFile.click()
    },
    async customerFileUpload() {
      this.$Spin.show()
      try {
        // let formData = new FormData()
        // formData.append('fileToUpload', this.$refs.customerFile.files[0])
        // formData.append('username', this.username)
        // formData.append('fl', '1')
        // formData.append('fileclass', '客户需求')
        // formData.append('npid', this.projectData.id)
        // let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpUpload', formData)
        // 上传文件
        let fileRep = await localFile.uploadFile(this.$refs.customerFile.files[0])

        if (!fileRep) {
          throw 'uploadError'
        }

        // 提交记录
        const params = {
          projectId: this.projectData.id,
          fileName: fileRep.fileName,
          fileGuid: fileRep.serviceGuid,
          fileSuffix: fileRep.extension,
          fileTypeId: '1',
          uploadPerson: this.username,
          fileTypeName: '客户需求'
        }
        let recordRep = await localFile.createFileRecord(params)

        if (!recordRep) {
          throw 'RecordError'
        }

        this.$Spin.hide()
        // 清空数据监听文件上传
        this.$refs.customerFile.value = ''
        
        this.$Message.success('上传成功')

        // 刷新数据
        this.getFileList(1)

        // 修改项目状态（只有项目在等待用户需求状态才修改）
        if (this.projectData.projectState === '等待用户需求') {
          let rep = await ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
            id: this.projectData.id,
            projectState: '文件编制中'
          })
        }

      } catch (err) {
        console.error(err)
        this.$refs.customerFile.value = ''
        this.$Spin.hide()
        this.$Message.error('上传失败')
      }
    },
    entrustFileSelect() {
      this.$refs.entrustFile.click()
    },
    async entrustFileUpload() {
      this.$Spin.show()
      try {
        // let formData = new FormData()
        // formData.append('fileToUpload', this.$refs.entrustFile.files[0])
        // formData.append('username', this.username)
        // formData.append('fl', '13')
        // formData.append('fileclass', '委托协议')
        // formData.append('npid', this.projectData.id)
        // let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpUpload', formData)

        // 上传文件
        let fileRep = await localFile.uploadFile(this.$refs.entrustFile.files[0])

        if (!fileRep) {
          throw 'uploadError'
        }

        // 提交记录
        const params = {
          projectId: this.projectData.id,
          fileName: fileRep.fileName,
          fileGuid: fileRep.serviceGuid,
          fileSuffix: fileRep.extension,
          fileTypeId: '13',
          uploadPerson: this.username,
          fileTypeName: '委托协议'
        }
        let recordRep = await localFile.createFileRecord(params)

        if (!recordRep) {
          throw 'RecordError'
        }

        this.$Spin.hide()
        this.$refs.entrustFile.value = ''

        this.$Message.success('上传成功')

        // 刷新数据
        this.getFileList(13)

      } catch (err) {
        this.$refs.entrustFile.value = ''
        this.$Spin.hide()
        this.$Message.error('上传失败')
      }
    },
    async downloadFile(file) {
      // const blobUrl = await localFile.downLoadBlob(file.fileGuid)
      // localFile.currentLoad(blobUrl, file.fileName)
      localFile.directLoadFile(file.fileGuid, file.fileName, file.fileSuffix)
    },
    // async showDownloadRecord(row) {
    //   this.$Spin.show()
    //   try {
    //     let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/GetDownFileUserList', qs.stringify({
    //       fileID: row['文件Guid']
    //     }))
    //     this.$Spin.hide()
    //     this.downloadRecord = rep.data
    //     this.downloadRecordVisible = true
    //   } catch(err) {
    //     console.error(err)
    //   }
    // },
    standardFile(type) {
      this.commissionFileType = type
      this.commissionModalChoose = true
    },
    commissionConfirm() {
      if (this.commissionFileType === '' || this.commissionType === '') {
        this.$Message.info('请选择类型')
        return
      }
      this.commissionModalChoose = false
      if (this.commissionFileType == 'fill') {
        switch (this.projectData.projectProperty){
          case '政府采购':
          case '企业采购':
          case '三大主体':
          case '国际标':
          case '军工(涉密)':
          case '军工(非涉密)':
          case '部队(涉密)':
          case '部队(非涉密)':
            let property = this.projectData.projectProperty
            if ((property == '军工(涉密)' || property == '军工(非涉密)' || property == '部队(涉密)' || property == '部队(非涉密)') && this.commissionType == 'standard') {
              this.$Modal.info({
                title: '提示',
                content: '暂无委托协议版本下载'
              })
              return
            }
            // 获取委托协议数据
            ajax.get(requestUrls.CLTrustAgreementInfo.GetPaged,{
              params:{
                filter: `projectNumber == "${this.projectData.projectFull}"`
              }
            }).then(res => {
              this.standardFileVisible = true
              if (res.data.result.items.length != 0) {
                this.argumentData = res.data.result.items[0]
              } else {
                this.argumentData = {}
              }
            })
            break
          default: 
            this.$Modal.info({
              title: '提示',
              content: '暂无委托协议版本下载'
            });
        }
      }
      if (this.commissionFileType == 'download') {
        this.standardFileVisible = true
        if (this.commissionType === 'standard') {
          this.standardFileUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D_go.cpt&projectName=${this.projectData.projectName}&projectNum=${this.projectData.projectFull}&cgfs=${this.projectData.buyerModes}&projectBudget=${this.projectData.purchaseBudget}&cgr=${this.projectData.purchaserName}&xmxz=${this.projectData.projectProperty}&zbpt=${this.projectData.bidPlatform}&xmlb=${this.projectData.buyerNature}&cgnr=${this.projectData.purchaseContent}&childcompany=${this.projectData.companyName}`
        }
        if (this.commissionType === 'staticStandard') {
          this.standardFileUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/委托协议/InitialVersion/委托协议_go.cpt&projectName=${this.projectData.projectName}&projectNum=${this.projectData.projectFull}&cgfs=${this.projectData.buyerModes}&projectBudget=${this.projectData.purchaseBudget}&cgr=${this.projectData.purchaserName}&xmxz=${this.projectData.projectProperty}&zbpt=${this.projectData.bidPlatform}&xmlb=${this.projectData.buyerNature}&cgnr=${this.projectData.purchaseContent}&childcompany=${this.projectData.companyName}`
        }
        if (this.commissionType === 'armyYear') {
          this.standardFileUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D_%5B519b%5D%5B5de5%5D%5B975e%5D%5B6d89%5D%5B5bc6%5D%5B5e74%5D%5B5ea6%5D.cpt&projectName=${this.projectData.projectName}&projectNum=${this.projectData.projectFull}&cgfs=${this.projectData.buyerModes}&projectBudget=${this.projectData.purchaseBudget}&cgr=${this.projectData.purchaserName}&xmxz=${this.projectData.projectProperty}&zbpt=${this.projectData.bidPlatform}&xmlb=${this.projectData.buyerNature}&cgnr=${this.projectData.purchaseContent}&childcompany=${this.projectData.companyName}`
        }
        if (this.commissionType === 'staticArmyYear') {
          this.standardFileUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/委托协议/InitialVersion/委托协议_军工非涉密年度.cpt&projectName=${this.projectData.projectName}&projectNum=${this.projectData.projectFull}&cgfs=${this.projectData.buyerModes}&projectBudget=${this.projectData.purchaseBudget}&cgr=${this.projectData.purchaserName}&xmxz=${this.projectData.projectProperty}&zbpt=${this.projectData.bidPlatform}&xmlb=${this.projectData.buyerNature}&cgnr=${this.projectData.purchaseContent}&childcompany=${this.projectData.companyName}`
        }
        if (this.commissionType === 'armySingle') {
          this.standardFileUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D_%5B519b%5D%5B5de5%5D%5B975e%5D%5B6d89%5D%5B5bc6%5D.cpt&projectName=${this.projectData.projectName}&projectNum=${this.projectData.projectFull}&cgfs=${this.projectData.buyerModes}&projectBudget=${this.projectData.purchaseBudget}&cgr=${this.projectData.purchaserName}&xmxz=${this.projectData.projectProperty}&zbpt=${this.projectData.bidPlatform}&xmlb=${this.projectData.buyerNature}&cgnr=${this.projectData.purchaseContent}&childcompany=${this.projectData.companyName}`
        }
        if (this.commissionType === 'staticArmySingle') {
          this.standardFileUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/委托协议/InitialVersion/委托协议_军工非涉密.cpt&projectName=${this.projectData.projectName}&projectNum=${this.projectData.projectFull}&cgfs=${this.projectData.buyerModes}&projectBudget=${this.projectData.purchaseBudget}&cgr=${this.projectData.purchaserName}&xmxz=${this.projectData.projectProperty}&zbpt=${this.projectData.bidPlatform}&xmlb=${this.projectData.buyerNature}&cgnr=${this.projectData.purchaseContent}&childcompany=${this.projectData.companyName}`
        }
      }
    },
    save() {
      this.$refs.agreement.save()
    }
  },
  watch: {
    projectData(val) {
      if (val) {
        // 1客户需求，13委托协议
        this.getFileList(1)
        this.getFileList(13)
      }
    }
  },
  filters: {
    filterUser(val) {
      if (!val) {
        return '***'
      }
      return val
    },
    formatTime(val) {
      if (!val) {
        return ''
      }
      return new Date(parseInt(val.slice(6, 19))).toLocaleString()
    }
  }
}
</script>

<style lang="less">
.record-item {
  padding: 10px 16px;
  position: relative;
  .time {
    position: absolute;
    right: 16px;
  }
}
.record-item + .record-item {
  border-top: 1px solid #ddd;
}
.proxy-modal {
  .ivu-modal {
    top: 20px;
  }
}
</style>
